"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UniqPrimitiveCollection = /** @class */ (function () {
    function UniqPrimitiveCollection(list) {
        this.size = 0;
        this.hash = Object.create(null);
        if (list) {
            list.forEach(this.add, this);
        }
    }
    UniqPrimitiveCollection.prototype.add = function (item) {
        this.hash[item] = true;
        this.size = Object.keys(this.hash).length;
        return this;
    };
    UniqPrimitiveCollection.prototype.has = function (key) {
        return key in this.hash;
    };
    UniqPrimitiveCollection.prototype.toArray = function () {
        return Object.keys(this.hash);
    };
    return UniqPrimitiveCollection;
}());
exports.UniqPrimitiveCollection = UniqPrimitiveCollection;
